var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigDvsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DVS_Check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #DVS_Check .cls-1 {\n        fill: #c5d75d;\n      }\n\n      #DVS_Check .cls-2 {\n        fill: #c3c3c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1156.94 -343.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_567",
    "data-name": "Pfad 567",
    className: "cls-1",
    d: "M1198.94,427.825a42,42,0,1,1,42-42A42.046,42.046,0,0,1,1198.94,427.825Zm0-79.484a37.484,37.484,0,1,0,37.484,37.484A37.527,37.527,0,0,0,1198.94,348.341Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_568",
    "data-name": "Pfad 568",
    className: "cls-1",
    d: "M1199.688,367.379a19.611,19.611,0,0,0-15.576-7.541c-.081,0-.161,0-.243,0-10.233,0-14.2,7.323-14.366,7.638l-.238.454.271.435a17.3,17.3,0,0,0,14.2,7.583c.126,0,.254,0,.382,0,9.548-.2,15.29-7.192,15.53-7.489l.418-.523Zm-15.533,6.481a5.969,5.969,0,1,1,5.97-5.97A5.976,5.976,0,0,1,1184.154,373.86Zm-12.8-6a14.047,14.047,0,0,1,8.663-5.809,7.144,7.144,0,0,0-.065,11.638A15.816,15.816,0,0,1,1171.359,367.856Zm17.336,5.571a7.146,7.146,0,0,0-.214-11.233,18.31,18.31,0,0,1,9.3,5.659A21.355,21.355,0,0,1,1188.694,373.427Z",
    transform: "translate(8.012 11.697)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    className: "cls-1",
    cx: 3.582,
    cy: 3.582,
    r: 3.582,
    transform: "translate(1188.359 375.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_569",
    "data-name": "Pfad 569",
    className: "cls-2",
    d: "M1188.07,397.408a22.076,22.076,0,1,1,22.077-22.075A22.1,22.1,0,0,1,1188.07,397.408Zm0-41A18.926,18.926,0,1,0,1207,375.332,18.95,18.95,0,0,0,1188.07,356.405Z",
    transform: "translate(4.718 4.872)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_570",
    "data-name": "Pfad 570",
    className: "cls-2",
    d: "M1197.75,388.606a3.142,3.142,0,0,1-2.228-.924L1185.1,377.26a3.149,3.149,0,0,1,4.454-4.454l10.424,10.422a3.151,3.151,0,0,1-2.226,5.378Z",
    transform: "translate(21.534 22.113)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigDvsCheck);
export default __webpack_public_path__ + "static/media/big-dvs-check.2afc0a2189f1eab48546d6fa771ff3ab.svg";
export { ForwardRef as ReactComponent };